const Fetcher = require('od-modules/utils/fetcher');
const logger = require('od-modules/utils/logger');
const withProps = require('components-framework/view/with_props');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const USER_INTERACTION_NEEDED_IFRAME_ID = 'iframe3ds';
const USER_INTERACTION_NEEDED_IFRAME_NAME = 'iframeUserInteractionNeeded';
const IFRAME_ID_SNIPPET_REGEXP = new RegExp(`(document\\.getElementById\\(\\')(${USER_INTERACTION_NEEDED_IFRAME_ID})(\\'\\))`, 'gm');
const IFRAME_TARGET_NAME_SNIPPET_REGEXP = new RegExp(`(setAttribute\\(\\'target\\'\\,\\')(${USER_INTERACTION_NEEDED_IFRAME_NAME})(\\'\\))`, 'gm');
const USER_INTERACTION_RECOVER_URL = `${Odigeo.Settings.property('appContext')}/service/shoppingbasket/recoverfromuserinteraction/`;
const BOOKING_STATUS = {
    BOOKING_CONFIRMED: 'BOOKING_CONFIRMED', BOOKING_PENDING: 'BOOKING_PENDING',
    BOOKING_PAYMENT_RETRY: 'BOOKING_PAYMENT_RETRY',
    BOOKING_REPRICING: 'BOOKING_REPRICING',
    BOOKING_REJECTED: 'BOOKING_REJECTED',
    BOOKING_ERROR: 'BOOKING_ERROR',
    BOOKING_RETAINED: 'BOOKING_RETAINED',
    BOOKING_USER_INTERACTION_NEEDED: 'BOOKING_USER_INTERACTION_NEEDED',
};
const STATUS_3DS = {
    OK: 'OK',
    KO: 'KO',
    LOADING: 'LOADING',
};
const USER_INTERACTION_NEEDED_NODE = 'userInteractionNeededDTO';
const HIDDEN_CLASS = 'odf-hidden';

const buildFromInputs = (value, param) => {
    return $('<input>', {
        value: value,
        name: param,
        type: 'hidden',
    });
};

const getUrlParameters = (url) => {
    const params = !Odigeo._.isEmpty(url)
        ? url.slice(url.indexOf('?') + 1).split('&')
        : [];

    return Odigeo._.reduce(params, (result, value) => {
        if (value.indexOf('=') !== -1) {
            const keyValue = value.split('=');
            result[keyValue[0]] = keyValue[1];
        }
        return result;
    }, {});
};

module.exports = (childView) => {
    return withProps(withRenderedMain(withCachedSelectors(Backbone.View.extend(Odigeo._.merge(childView, {
        selectors: {
            userInteractionLayer: '.user_interaction_layer',
            paymentFormLayer: '.payment_form_layer',
            paymentLoading: '.loading_layer',
            checkoutForm: '.one_click_checkout_form',
            userFeedbackLayer: '.user_feedback_layer',
            feedbackButtonClose: '.feedback_button_close',
        },
        events: {
            'tap .feedback_button_close_success': 'onCloseSuccessFeedBack',
            'tap .feedback_button_close_error': 'onCloseErrorFeedBack',
            'tap .feedback_button_close_retry': 'onCloseRetryFeedBack',
        },

        initialize(options) {
            const paymentFormId = `${this.id}-payment-form`;
            const binDetectionId = `${this.id}-bin-detection`;
            this.setupDynamicIdPaymentForm(paymentFormId);
            this.htmlWidgetsFromJsp = Odigeo.autoLoadHtmlWidgetsFromJspAsync({
                getOneClickCheckout: [
                    paymentFormId,
                    'payment',
                    'one-click-payment-form-generic',
                    [['post-booking-bin-detection-generic', binDetectionId]],
                ],
                getOneClickCheckoutBinDetection: [
                    binDetectionId,
                    'post_booking_bin_detection',
                    'post-booking-bin-detection-generic',
                ],
            });

            this.htmlWidgetsFromJsp.getOneClickCheckout();
            this.htmlWidgetsFromJsp.getOneClickCheckoutBinDetection();
            this.model.set('productType', options.productType);
            this.model.set('isCheckIn', options.isCheckIn);
            this.contentKeys = options.contentKeys;
            this.$cachedSelectors.paymentLoading.html(this.templates.loading());
            this.bindEvents();
        },
        bindEvents() {
            this.listenTo(this.model, 'userInteractionNeeded', this.manageUserInteractionNeeded);
            this.listenTo(this.model, 'confirm', this.manageConfirm);
            this.listenTo(this.model, 'paymentRetry', this.managePaymentRetry);
            this.listenTo(this.model, 'shoppingBasketError', this.manageErrors);
            this.listenTo(this.model, 'setPaymentOptions', this.setPaymentOptions);
        },

        setPaymentOptions(availableCollectionMethods) {
            const availableCreditCards = Odigeo._.get(availableCollectionMethods, '[0].info.cardTypes');
            if (!availableCreditCards) {
                const errorMessage = 'Invalid collection methods';
                logger.message(errorMessage);
                throw new Error(errorMessage);
            }

            this.togglePaymentForm({
                show: true,
                isLoading: false,
            });
            const shoppingBasketId = this.model.get('shoppingBasketId');
            this.htmlWidgetsFromJsp.getOneClickCheckout().execute('setPaymentOptions', shoppingBasketId, availableCreditCards);
        },

        setupDynamicIdPaymentForm(id) {
            this.$cachedSelectors.checkoutForm.attr('id', id);
        },
        onCloseSuccessFeedBack() {
            this.toggleFeedbackLayer();
            Odigeo.trigger(`${this.id}:close`);
        },

        onCloseErrorFeedBack() {
            this.toggleFeedbackLayer();
            Odigeo.trigger(`${this.id}:close`);
        },

        onCloseRetryFeedBack() {
            this.toggleFeedbackLayer();
            Odigeo.trigger(`${this.id}:retryPayment`);
        },

        manageConfirm(options = {}) {
            if (!options.customFeedback) {
                this.toggleFeedbackLayer(BOOKING_STATUS.BOOKING_CONFIRMED);
            }
            Odigeo.trigger(`${this.id}:onCheckoutConfirm`);
        },

        managePaymentRetry(options = {}) {
            if (!options.customFeedback) {
                this.toggleFeedbackLayer(BOOKING_STATUS.BOOKING_PAYMENT_RETRY);
            }
            Odigeo.trigger(`${this.id}:onCheckoutPaymentRetry`);
        },

        manageUserInteractionNeeded(checkoutResponse) {
            this.renderIframe();
            const jsSnippet = Odigeo._.get(checkoutResponse, `${USER_INTERACTION_NEEDED_NODE}.javascriptSnippet`);
            if (!Odigeo._.isEmpty(jsSnippet)) {
                this.evaluateJavascriptSnippet(jsSnippet);
            } else {
                this.redirectToUrl(checkoutResponse);
            }
        },

        manageErrors(options = {}) {
            if (!options.customFeedback) {
                this.toggleFeedbackLayer(BOOKING_STATUS.BOOKING_ERROR);
                this.model.set('shoppingBasketId');
            }

            if (options.genericError) {
                if (!this.isCheckIn()) {
                    this.hideAllLayers();
                }
                this.model.set('shoppingBasketId');
                Odigeo.trigger(`${this.id}:genericError`);
            } else {
                Odigeo.trigger(`${this.id}:onCheckoutPaymentRetry`);
            }
        },

        evaluateJavascriptSnippet(jsSnippet) {
            const parsedJsSnippet = jsSnippet
                .replace(IFRAME_ID_SNIPPET_REGEXP, `$1${this.userInteractionIframeId}$3`)
                .replace(IFRAME_TARGET_NAME_SNIPPET_REGEXP, `$1${this.userInteractionIframeTargetName}$3`);

            window.iframe3dsActive = true;
            eval(parsedJsSnippet);
        },

        redirectToUrl(checkoutOrResumeResponse) {
            const redirectUrl = Odigeo._.get(checkoutOrResumeResponse, `${USER_INTERACTION_NEEDED_NODE}.redirectUrl`);
            const parameters = Odigeo._.get(checkoutOrResumeResponse, `${USER_INTERACTION_NEEDED_NODE}.parameters`);

            if (!Odigeo._.isEmpty(redirectUrl)) {
                if (Odigeo._.isEmpty(parameters)) {
                    this.handle3DSRedirectIntoIframe(redirectUrl);
                } else {
                    this.createAndSubmitFormWithData(checkoutOrResumeResponse);
                }
            }
        },

        handle3DSRedirectIntoIframe(redirectUrl) {
            const $psd2Iframe = this.$cachedSelectors.userInteractionLayer.find('iframe');
            $psd2Iframe.attr('src', redirectUrl);
            $psd2Iframe.removeClass(HIDDEN_CLASS);
        },

        createAndSubmitFormWithData(checkoutOrResumeResponse) {
            const redirectUrl = Odigeo._.get(checkoutOrResumeResponse, `${USER_INTERACTION_NEEDED_NODE}.redirectUrl`);
            const parameters = Odigeo._.get(checkoutOrResumeResponse, `${USER_INTERACTION_NEEDED_NODE}.parameters`, {});
            const method = Odigeo._.get(checkoutOrResumeResponse, `${USER_INTERACTION_NEEDED_NODE}.sendType`);

            const $psd2Iframe = this.$cachedSelectors.userInteractionLayer.find('iframe');
            const $urlParamsInputs = Odigeo._.map(getUrlParameters(redirectUrl), buildFromInputs);
            const $requestParamsInputs = Odigeo._.map(parameters, buildFromInputs);
            const formAttributes = {
                target: this.userInteractionIframeTargetName,
                action: redirectUrl,
                method,
            };

            $('<form>', formAttributes)
                .append($requestParamsInputs)
                .append($urlParamsInputs)
                .appendTo(this.$cachedSelectors.userInteractionLayer)
                .submit();
            $psd2Iframe.removeClass(HIDDEN_CLASS);
        },

        messageReceivedFromIframe(event, $iframe, options) {
            if (event.source === $iframe.get(0).contentWindow) {
                const payment3dsStatus = Odigeo._.get(event, 'data.payment3ds');
                switch (payment3dsStatus) {
                    case STATUS_3DS.OK:
                        if (this.isCheckIn()) {
                            this.closeIframeContainer();
                        }
                        this.recoverCheckoutFromUserInteraction(
                            this.model.onCheckoutSuccess.bind(this.model),
                            this.manageErrors.bind(this),
                            options);
                        break;
                    case STATUS_3DS.LOADING:
                        this.recoverCheckoutFromUserInteraction(
                            this.createAndSubmitFormWithData.bind(this),
                            this.manageErrors.bind(this),
                            options);
                        break;
                    case STATUS_3DS.KO:
                    default:
                        if (this.isCheckIn()) {
                            this.closeIframeContainer();
                        }
                        this.manageErrors(options);
                        break;
                }
            }
        },

        recoverCheckoutFromUserInteraction(success, error, options) {
            return Fetcher.get(USER_INTERACTION_RECOVER_URL + this.model.get('shoppingBasketId')).json()
                .then((response) => success(response, options))
                .catch(() => error(options));
        },

        togglePaymentForm(info) {
            const isShown = !this.$cachedSelectors.paymentFormLayer.hasClass(HIDDEN_CLASS);

            this.hideAllLayers();

            const show = Odigeo._.get(info, 'show', isShown);
            const isLoading = Odigeo._.get(info, 'isLoading');

            this.$cachedSelectors.paymentFormLayer.toggleClass(HIDDEN_CLASS, !show);
            if (isLoading !== undefined) {
                this.$cachedSelectors.paymentLoading.toggleClass(HIDDEN_CLASS, !isLoading);
                this.$cachedSelectors.checkoutForm.toggleClass(HIDDEN_CLASS, isLoading);
            }
        },

        toggleInteractionLayer(show) {
            if (!this.isCheckIn()) {
                this.hideAllLayers();
            }
            this.$cachedSelectors.userInteractionLayer.toggleClass(HIDDEN_CLASS, !show);
        },
        toggleFeedbackLayer(status) {
            this.hideAllLayers();
            this.$cachedSelectors.userFeedbackLayer.empty();
            this.$cachedSelectors.userFeedbackLayer.toggleClass(HIDDEN_CLASS, false);

            switch (status) {
                case BOOKING_STATUS.BOOKING_CONFIRMED:
                    this.$cachedSelectors.userFeedbackLayer.html(this.templates.feedbackSuccess({
                        buttonClassName: 'feedback_button_close_success',
                        keys: this.keys,
                        keyValues: this.contentKeys,
                    }));
                    break;
                case BOOKING_STATUS.BOOKING_PAYMENT_RETRY:
                    this.$cachedSelectors.userFeedbackLayer.html(this.templates.feedbackError({
                        buttonClassName: 'feedback_button_close_retry',
                        keys: this.keys,
                        keyValues: this.contentKeys,
                    }));
                    break;
                case BOOKING_STATUS.BOOKING_ERROR:
                    this.$cachedSelectors.userFeedbackLayer.html(this.templates.feedbackError({
                        buttonClassName: 'feedback_button_close_error',
                        keys: this.keys,
                        keyValues: this.contentKeys,
                    }));
                    break;
                default:
                    this.$cachedSelectors.userFeedbackLayer.toggleClass(HIDDEN_CLASS, true);
                    this.togglePaymentForm({
                        show: true,
                        isLoading: false,
                    });
                    break;
            }
        },
        hideAllLayers() {
            this.$cachedSelectors.paymentFormLayer.toggleClass(HIDDEN_CLASS, true);
            this.$cachedSelectors.userFeedbackLayer.toggleClass(HIDDEN_CLASS, true);
            this.$cachedSelectors.userInteractionLayer.toggleClass(HIDDEN_CLASS, true);
        },
        isCheckIn() {
            return this.model.get('isCheckIn');
        },
        renderIframeTemplate() {
            this.userInteractionIframeId = `${USER_INTERACTION_NEEDED_IFRAME_ID}_${this.id}`;
            this.userInteractionIframeTargetName = `${USER_INTERACTION_NEEDED_IFRAME_NAME}_${this.id}`;

            if (this.isCheckIn()) {
                this.$cachedSelectors.userInteractionLayer.html(this.templates.iframeCheckin({
                    keys: this.keys,
                    iframeId: this.userInteractionIframeId,
                    iframeName: this.userInteractionIframeTargetName,
                }));
            } else {
                this.$cachedSelectors.userInteractionLayer.html(this.templates.iframe({
                    iframeId: this.userInteractionIframeId,
                    iframeName: this.userInteractionIframeTargetName,
                }));
            }
        },
    })))));
};
